import styled from "styled-components";

const ErrorMessage = styled.span`
	color: red;
	font-size: 22px;
	padding-left: 10px;
`;

export default ErrorMessage;
